module.exports = __webpack_public_path__ + "static/media/vieux-logo.44c91fb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/vieux-logo.svg
// module id = 607
// module chunks = 0